import {PAGE_CONTAINER} from '@/store/types'

export default {
  namespaced: true,
  state: {
    menuSelected: String,
    menuFocused: String,
    showMenu: false,
    showAdm: false
  },
  getters: {
    showMenu (state) {
      return state.showMenu
    },
    showAdm (state) {
      return state.showAdm
    }
  },
  mutations: {
    [PAGE_CONTAINER.SET_MENU_SELECTED] (state, value) {
      state.menuSelected = value
      state.menuFocused = null
      state.showMenu = false
    },
    [PAGE_CONTAINER.SET_MENU_FOCUSED] (state, value) {
      state.menuFocused = value
    },
    [PAGE_CONTAINER.SHOW_MENU] (state, value) {
      state.showMenu = value
    },
    [PAGE_CONTAINER.SHOW_ADM] (state, value) {
      state.showAdm = value
    }
  },
  actions: {
    setMenuSelected (store, value) {
      store.commit(PAGE_CONTAINER.SET_MENU_SELECTED, value)
    },
    setMenuFocused (store, value) {
      store.commit(PAGE_CONTAINER.SET_MENU_FOCUSED, value)
    },
    setShowMenu (store, value) {
      store.commit(PAGE_CONTAINER.SHOW_MENU, value)
    },
    setShowAdm (store, value) {
      store.commit(PAGE_CONTAINER.SHOW_ADM, value)
    }
  }
}
